import _ from 'lodash';
import moment from 'moment';
import apiClient from './api-client';
import { globalVariables } from '../global';
import dialogService from './dialog-service';
import { JSON_CONTENT_TYPE } from '../utils';
import { BUILT_IN_VARIABLES, AUTO_RENEW_PERIOD } from '../constants';
import userService from './user-service';
import { renew } from './auth-service';
import { cloneTrim } from '../utils/obj-trim';

function deepReplace(obj, prevVal, newVal) {
  // const newObject = _.clone(obj);
  _.each(obj, (val, key) => {
    if (val === prevVal) {
      /* eslint-disable-next-line */ /* for performance */
      obj[key] = newVal;
    } else if (typeof (val) === 'object' || Array.isArray(val)) {
      /* eslint-disable-next-line */
      obj[key] = deepReplace(val, prevVal, newVal);
    }
  });

  return obj;
}

const autoRenew = async () => {
  if (userService.isLoggedIn()) {
    const { expire } = userService.getCurrentUser();
    const now = moment().valueOf() / 1000;
    const diff = Math.floor(expire - now);
    if (diff <= AUTO_RENEW_PERIOD) {
      const renewResult = await renew();
      if (renewResult) {
        return;
      }
    } else {
      return;
    }
  }
  await dialogService.login.show();
};

const throttledAutoRenew = _.throttle(autoRenew, 500, { trailing: false });

const postRequest = async (params = {}, endpoint) => {
  const newEndpoint = _.cloneDeep(endpoint);
  await throttledAutoRenew();
  let accessToken = '';
  let userId = 0;
  let siteId = 0;
  let siteGroupId = 0;
  let siteGroupName = '';
  const currentUser = userService.getCurrentUser();
  if (currentUser) {
    accessToken = currentUser.access_token;
    userId = currentUser.id;
  }
  if (globalVariables.currentSite) {
    siteId = globalVariables.currentSite.id;
    siteGroupId = globalVariables.currentSite.groupId;
    siteGroupName = globalVariables.currentSite.groupName;
  }
  let url = process.env.REACT_APP_BACKEND_API_URL;
  let headers = {
    'Content-Type': JSON_CONTENT_TYPE,
    Authorization: `${accessToken}`,
  };
  if (newEndpoint && Object.keys(newEndpoint).length) {
    const envEndpoint = newEndpoint[process.env.NODE_ENV] || newEndpoint;
    url = envEndpoint.url;
    headers = envEndpoint.header || envEndpoint.headers || {};
    Object.keys(headers).forEach((key) => {
      headers[key] = (headers[key] || '').replace(BUILT_IN_VARIABLES.accessToken, accessToken);
    });
  }

  const data = { ...params };
  if (data.variables) {
    data.variables = cloneTrim(data.variables);
    deepReplace(data.variables, BUILT_IN_VARIABLES.userId, userId);
    deepReplace(data.variables, BUILT_IN_VARIABLES.siteId, siteId);
    deepReplace(data.variables, BUILT_IN_VARIABLES.siteGroupId, siteGroupId);
    deepReplace(data.variables, BUILT_IN_VARIABLES.siteGroupName, siteGroupName);
    deepReplace(data.variables, BUILT_IN_VARIABLES.now, new Date().toISOString());
  }
  return apiClient({
    method: 'POST',
    url,
    data,
    headers,
  });
};

const scriptTag = 'script';
const loadScript = ({ id, src }) => new Promise((resolve, reject) => {
  if (document.getElementById(id)) {
    resolve();
    return;
  }

  dialogService.loadingProgress.show();
  const script = document.createElement(scriptTag);
  document.body.appendChild(script);
  script.onload = () => {
    dialogService.loadingProgress.hide();
    script.id = id;
    resolve();
  };
  script.onerror = reject;
  script.async = true;
  script.src = src;
});

const getRequest = (url) => apiClient({
  method: 'GET',
  url,
});
export {
  getRequest,
  postRequest,
  loadScript,
};
